// Rule-based smart tower recommendation engine
export function recommendTower({ purpose, environment, coverage, space }) {
  let towerType = "Self-Support";
  let height = "30m";
  let reasonKeys = [];

  // Determine tower type
  if (environment === "rooftop") {
    towerType = "Rooftop Pole";
  } else if (environment === "urban" && space === "limited") {
    towerType = "Monopole";
  } else if (purpose === "broadcast" || (coverage === "high" && space === "ample")) {
    towerType = "Guyed";
  } else if (coverage === "high" || purpose === "microwave") {
    towerType = "4-Leg Self-Support";
  } else if (space === "limited") {
    towerType = "Monopole";
  } else if (space === "moderate") {
    towerType = "3-Leg Self-Support";
  } else {
    towerType = "4-Leg Self-Support";
  }

  // Small cell override
  if (purpose === "smallcell") {
    towerType = environment === "rooftop" ? "Rooftop Pole" : "Monopole";
  }

  // Determine height
  if (environment === "rooftop") {
    height = "6m – 12m";
  } else if (coverage === "low") {
    height = "12m – 15m";
  } else if (coverage === "med") {
    height = "20m – 30m";
  } else {
    height = "40m – 60m+";
  }

  // Build solution summary
  const solutionMap = {
    macro: "Macro coverage package: tower supply, foundation, antenna mounts, earthing & aviation lighting.",
    smallcell: "Densification package: compact structure, concealed cabling, integrated small-cell brackets.",
    microwave: "Backhaul package: rigid structure with microwave mounts, alignment platforms & path clearance.",
    broadcast: "High-power package: tall guyed/self-support structure with reinforced foundations & full lighting.",
  };

  return {
    towerType,
    height,
    solution: solutionMap[purpose] || solutionMap.macro,
  };
}
